module.exports = __webpack_public_path__ + "templates/android-installation-prompt.component.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/installation-prompt/android-installation-prompt/android-installation-prompt.component.html
// module id = H0Fd
// module chunks = 1